<template>
    <article :class="classes">
        <div class="c-article__head">
            <slot name="header"/>
        </div>
        <!-- /.c-article__head -->
        <div class="c-article__content">
            <slot name="content"/>
        </div>

        <div class="c-article__img">
            <slot name="img"/>
        </div>
        <!-- /.c-article__img -->
    </article>
</template>

<script>
    export default {
        props: {
            results: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {
            classes() {
                return {
                    "c-article": true,
                    results: this.results
                };
            }
        }
    };
</script>

<style lang="scss">
    .c-article {
        position: relative;

        &__head {
            max-width: 33.4375rem;
            padding-bottom: 0.875rem;

            h1 {
                line-height: 2.4375rem;
                margin: 0px;
                padding-bottom: 0.9375rem;
                text-transform: none;

                @media screen and (max-width: 1200px) {
                    font-size: 1.8rem;
                }
            }

            h5 {
                margin: 0;
                line-height: 2.4375rem;
            }

            &--intro {
                padding: 2rem 0 4rem;

                h1 {
                    margin: 0;
                }
            }
        }

        &__content {
            width: 45%;
            margin-bottom: 5.625rem;

            p {
                margin-bottom: 3.75rem;

                a {
                    font-weight: 500;
                    margin-bottom: 3.875rem;
                    display: block;
                }
            }

            &--results {
                margin-bottom: 0;

                h1 {
                    font-weight: 400;
                    color: #d8d8d8;
                    margin: 0;

                    span {
                        color: #d8d8d8;
                    }
                }

                p {
                    font-weight: 400;
                    margin: 0;
                    padding-top: 1.5625rem;
                    padding-bottom: 3.125rem;
                }

                &-container {
                    width: 100%;
                    display: block;
                }
            }

            &--intro {
                max-width: 80%;
                margin: auto;

                p {
                    margin: 0;
                    padding-bottom: 4rem;
                }
            }
        }

        &__img {
            position: absolute;
            width: 55%;
            top: 3rem;
            left: 36.25rem;

            @media screen and (max-width: 1200px) {
                width: 32.5rem;
                top: 2.5rem;
                right: 0;
                left: 33.125rem;
            }

            img {
                width: 100%;
            }
        }

        &-intro {
            max-width: 70%;
            margin: auto;
            text-align: center;
        }

        @media screen and (max-width: 1024px) {
            &__content {
                width: 50%;
            }

            &__img {
                width: 18.75rem;
                top: 8.8125rem;
                left: 30.625rem;
            }
        }

        @media screen and (max-width: 767px) {
            &__head {
                max-width: 50rem;
                padding-bottom: 0;

                h1 {
                    font-size: 1.5rem;
                    text-align: center;
                }

                h5 {
                    padding: 1.25rem 0 0 5%;
                }
            }

            &__content {
                width: 100%;
                margin-bottom: 0;
                padding: 0 5%;
                text-align: center;

                p {
                    text-align: left;
                    margin-top: 0;
                }
            }

            &__img {
                display: none;
            }
        }
    }
</style>
